<template>
  <div>
    <title-edit header="Sub menu" />
    <line-hr />
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        &nbsp;
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <v-app class="switch-app">
          <v-switch label="Publish" color="tcdc_color" v-model="form.is_publish"></v-switch>
        </v-app>
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Service* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <select-option :items="optionService" @update="updateService" :model="form.service_id" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Sub menu TH* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.title_th" @update="updateMenuTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Sub menu EN* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.title_en" @update="updateMenuEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Description TH* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-editor :model="form.description_th" @update="updateDescriptionTH" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Description EN* :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-editor :model="form.description_en" @update="updateDescriptionEN" />
      </v-col>
    </div>
    <div class="row">
      <v-col cols="12" sm="4" class="label">
        <label>Slug Url :</label>
      </v-col>
      <v-col cols="12" sm="5" xs="12">
        <input-text-field :model="form.slug_url" @update="updateSlugUrl" />
      </v-col>
    </div>
    <line-hr />
    <div class="row text-right">
      <v-spacer></v-spacer>
      <delete-button @click.native="deleteSubMenu" />
<!--      <preview-button />-->
      <save-button @click.native="saveSubMenu" />
    </div>
  </div>
</template>

<script>
import TitleEdit from "../../../components/TitleHeader/TitleEdit";
import LineHr from "../../../components/Icon/line-hr";
import SelectOption from "../../../components/Input/selectOption";
import InputTextField from "../../../components/Input/InputTextField";
import InputEditor from "../../../components/Input/InputEditor";
import DeleteButton from "../../../components/Button/DeleteButton";
import PreviewButton from "../../../components/Button/PreviewButton";
import SaveButton from "../../../components/Button/SaveButton";
import { mapState } from "vuex";
import InputImageUpload from "../../../components/Input/InputImageUpload";
import Swal from "sweetalert";
export default {
  name: "SubMenu",
  components: {
    InputImageUpload,
    SaveButton,
    PreviewButton,
    DeleteButton,
    InputEditor,
    InputTextField,
    SelectOption,
    LineHr,
    TitleEdit
  },
  data() {
    return {
      optionMenu: [],
      optionService: []
    };
  },
  computed: {
    ...mapState({
      form: state => {
        return state.SubMenu.form;
      }
    })
  },
  created() {
    this.getMenuData();
    this.getServiceData();
  },
  methods: {
    getMenuData() {
      this.$store.dispatch("Menu/getAllMenu").then(res => {
        this.optionMenu = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.menu_id,
            text: type.title
          }))
        ];
      });
    },
    getServiceData() {
      this.$store.dispatch("Services/getServiceAll").then(res => {
        this.optionService = [
          { text: "Select", value: "" },
          ...res.map(type => ({
            value: type.service_id,
            text: type.title
          }))
        ];
      });
    },
    goToSubMenuTable() {
      this.$router.push("/menu/sub-menu");
    },
    validateSave() {
      if (!this.form.menu_id) {
        Swal('','Please select Menu !','error');
        return false;
      } else if (!this.form.service_id) {
        Swal('','Please insert Service !','error');
        return false;
      } else if (!this.form.title_th) {
        Swal('','Please insert Menu TH !','error');
        return false;
      } else if (!this.form.title_en) {
        Swal('','Please insert Menu EN !','error');
        return false;
      } else if (!this.form.description_th) {
        Swal('','Please insert Description TH !','error');
        return false;
      } else if (!this.form.description_en) {
        Swal('','Please insert Description EN !','error');
        return false;
      } else {
        return true;
      }
    },
    saveSubMenu() {
      if (this.validateSave()) {
        this.$store
          .dispatch("SubMenu/saveSubMenu", {
            id: this.form.sub_menu_id,
            data: this.form
          })
          .then(res => {
            Swal(res.response_msg);
            if (res.response_code == 200) {
              this.goToSubMenuTable();
            }
          })
          .catch(() => {
            Swal('','Cannot save menu data','error');
          });
      }
    },
    deleteSubMenu() {
      this.$store
        .dispatch("SubMenu/deleteSubMenu", this.form.sub_menu_id)
        .then(res => {
          Swal(res.response_msg);
          if (res.response_code == 200) {
            this.goToSubMenuTable();
          }
        })
        .catch(() => {
          Swal('','Cannot delete menu data','error');
        });
    },
    updateMenu(val) {
      this.form.menu_id = val;
    },
    updateService(val) {
      this.form.service_id = val;
    },
    updateMenuTH(val) {
      this.form.title_th = val;
    },
    updateMenuEN(val) {
      this.form.title_en = val;
    },
    updateDescriptionTH(val) {
      this.form.description_th = val;
    },
    updateDescriptionEN(val) {
      this.form.description_en = val;
    },
    updateSlugUrl(val) {
      this.form.slug_url = val;
    }
  }
};
</script>

<style scoped>
@import "../../../assets/css/switch.css";
</style>
